module.exports = __webpack_public_path__ + "static/media/icon_strategic_questions_summary.e53a3a4f.svg";